import { buildYourOwnValue } from './findNearestCaratValue';

/**
 * Largest center size the style can show. Pass availableCodes (the sizes the
 * API returns) whenever they are at hand - the map can run ahead of the
 * backend, so on its own it reports a size the style does not offer yet.
 */
export const getCenterDiamondSize = (exclusionOption: string[], availableCodes?: string[]) => {
  const allowed = Object.keys(buildYourOwnValue).filter(key => !exclusionOption?.includes(key));
  const offered = allowed.filter(key => availableCodes?.includes(key));
  const codes = offered.length ? offered : allowed;
  return codes.length ? Math.max(...codes.map(Number)).toString() : '';
};